export const verifySessionEndpoint = '/authentication-ms/v1/verify-session';

export const logoutUserEndpoint = '/authentication-ms/v1/logout';
export const accessUserEndpoint = '/authentication-ms/ms/auth/tp/access';

/* Identifies the jwt token when it is serialized. */
export const authTokenKey = 'auth-token';

/* Identifies token when it is serialized. */
export const authTokenKeyApp = 'token';
/* Identifies account when it is serialized. */
export const authAccountKey = 'account';
/* Identifies siteid when it is serialized. */
export const authSiteIdKey = 'siteid';

/* Identifies cod_promozione query params. */
export const codePromozione = 'cod_promozione';

/* Identifies cod_promozione query params. */
export const promoCodeLocalStorage = 'CRMCAMPAIGNPROMO';

export const cancelCallbackUrlKey = 'cancelcallbackurl';

export const endCallbackUrlKey = 'endcallbackurl';
